<template>
  <el-row>
    <div class="col-12">
      <h1 class="confirm-address-title">Confirm Business Contact Address</h1>
      <h5>Please confirm your business contact address or update it if needed.</h5>
      <div class="form-group">
        <label class="form-label" for="address1-input">Address</label>
        <el-form-item :error="errors.address1">
          <el-input
            id="address1-input"
            v-bind="address1"
            placeholder="1234 Yesler Way"
            type="text"
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <label class="form-label" for="address2-input">Address 2</label>
        <el-input
          id="address2-input"
          v-bind="address2"
          placeholder="PO Box #, Unit #"
          type="text"
        />
      </div>
      <div class="form-group">
        <label class="form-label" for="city-input">City</label>
        <el-form-item :error="errors.city">
          <el-input id="city-input" v-bind="city" placeholder="City" type="text" />
        </el-form-item>
      </div>
      <div class="row">
        <div class="col-md form-group">
          <label class="form-label" for="state-input">State</label>
          <el-select id="state-input" v-bind="state" name="State" filterable>
            <el-option
              v-for="stateVal in states.data().states"
              :key="stateVal.abbreviation"
              :label="stateVal.abbreviation"
              :value="stateVal.abbreviation"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md form-group">
          <label class="form-label" for="zip-input">Zip Code</label>
          <el-form-item :error="errors.zip">
            <el-input id="zip-input" v-bind="zip" name="clientZip" maxlength="5" />
          </el-form-item>
        </div>
      </div>

      <div v-show="isTaxableLocation" class="confirm-address-disclaimer pb-2">
        Please ensure that you provide the correct and complete business address associated with
        your account. Your state and local tax rates are calculated based on this address, and
        entering inaccurate information may result in incorrect tax assessments.
      </div>

      <div class="button-area">
        <div class="left-button">
          <el-button class="my-2" type="primary" @click="emit('click-back')">Back</el-button>
        </div>
        <div class="right-button">
          <el-button
            :disabled="hasErrors"
            :loading="isSubmitting"
            class="my-2"
            type="primary"
            @click="handleSubmitAddress"
            >Next</el-button
          >
        </div>
      </div>
    </div>
  </el-row>
</template>

<script setup>
import { computed, defineEmits, ref } from 'vue';
import { states } from '@/utils/mixins';
import { isTaxableAddress } from '@/utils/addressUtils';
import useConfirmAddressEditFormScript from './ConfirmAddressEditFormScript';

const { errors, data, submitForm } = {
  ...useConfirmAddressEditFormScript(),
};

const { address1, address2, city, state, zip } = { ...data };

const emit = defineEmits(['click-next', 'request-close']);

const isSubmitting = ref(false);
const hasErrors = computed(() => Object.keys(errors.value).length > 0);
const isTaxableLocation = computed(() => isTaxableAddress({ state: state.value.modelValue }));

async function handleSubmitAddress() {
  if (isSubmitting.value) {
    return;
  }
  isSubmitting.value = true;

  await submitForm()
    .then(() => {
      emit('click-next');
    })
    .finally(() => {
      isSubmitting.value = false;
    });
}
</script>

<style>
.confirm-address-title {
  line-height: 24px;
  color: #303133;
}

.confirm-address-disclaimer {
  font-size: 12px;
  color: #9aa0ac;
}

.button-area {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.button-area .left-button {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.button-area .right-button {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
</style>
